module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/buttons/button-nav-border-72.png"+" 72w",
        images: [{path: __webpack_public_path__ + "assets/images/buttons/button-nav-border-72.png",width: 72,height: 70}],
        src: __webpack_public_path__ + "assets/images/buttons/button-nav-border-72.png",
        toString: function(){return __webpack_public_path__ + "assets/images/buttons/button-nav-border-72.png"},
        
        width: 72,
        height: 70
      }